// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}
@media (min-width: 1024px) {
  :host {
    height: 100%;
  }
}

ion-card {
  width: 100%;
  height: 100%;
  margin: 0;
  overflow: hidden;
  box-sizing: border-box;
}
@media (max-width: 599px) {
  ion-card {
    min-height: 85vh;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  ion-card {
    height: auto;
    min-height: 85vh;
    overflow: visible;
  }
}
@media (min-width: 1024px) {
  ion-card {
    display: flex;
    flex-direction: column;
  }
}

.time-filter {
  position: absolute;
  z-index: 990;
  width: 70%;
  height: 100%;
  right: var(--spacing-small);
}

.download-qr-button {
  opacity: 1;
  position: relative;
  z-index: 990;
  width: clamp(24px, 4vh, 36px) !important;
  height: clamp(24px, 4vh, 36px) !important;
  min-width: 0 !important;
  min-height: 0 !important;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  border: 2px solid var(--ion-color-primary) !important;
  margin: 0 var(--spacing-small);
  padding: 0 !important;
  transition: all 0.3s ease;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  aspect-ratio: 1;
}
@media (max-width: 599px) {
  .download-qr-button {
    display: none !important;
  }
}
.download-qr-button ion-icon {
  font-size: clamp(14px, 2.5vh, 20px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  color: var(--ion-color-primary);
}
.download-qr-button::after {
  content: attr(title);
  position: absolute;
  bottom: -35px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s ease;
  z-index: 1000;
}
.download-qr-button:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);
  transform: translateY(-2px);
  border-color: var(--ion-color-primary);
  background-color: white;
}
.download-qr-button:hover ion-icon {
  color: var(--ion-color-primary);
}
.download-qr-button:hover::after {
  opacity: 1;
}
.download-qr-button:active {
  transform: translateY(0);
}

.battery-title {
  font-weight: bold;
  width: auto;
  color: var(--ion-color-primary) !important;
}
@media (max-width: 599px) {
  .battery-title {
    font-size: clamp(0.65rem, 1.3vw, 0.85rem);
    line-height: 1.1;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .battery-title {
    font-size: clamp(0.75rem, 1.2vw, 0.95rem);
  }
}
@media (min-width: 1024px) {
  .battery-title {
    font-size: clamp(0.85rem, 1vw, 1.1rem);
  }
}

.card-header {
  height: 5vh;
  max-height: 5vh;
  min-height: 0 !important;
  display: flex;
  align-items: center;
  padding: 0 var(--spacing-small);
  color: white !important;
  border-left: 5px solid var(--ion-color-primary);
  background: linear-gradient(90deg, color-mix(in srgb, var(--ion-color-primary) 12%, white), color-mix(in srgb, var(--ion-color-primary) 3%, white)) !important;
  overflow: hidden;
}

.header-content {
  display: flex;
  align-items: center;
  gap: var(--spacing-medium);
  width: 100%;
}

ion-chip {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

.hide-label {
  display: none !important;
}

.table-chip-button {
  font-size: clamp(0.35rem, 1.8vmin, 1.25rem);
}

.qr-button-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.popover-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qr-buttons {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  background-color: var(--ion-color-primary);
  color: white;
  padding: var(--spacing-small);
  text-align: center;
  transition: background-color 0.3s, filter 0.3s;
}

.qr-buttons:hover {
  background-color: rgba(1, 1, 1, 0.1);
}

.qr-buttons:hover ion-icon {
  color: var(--ion-color-primary);
}

.batteriesQRCodePopover ion-grid,
.batteriesQRCodePopover ion-col,
.batteriesQRCodePopover ion-row {
  padding: 0;
  height: 100%;
}

.batteriesQRCodePopover ion-col:first-child {
  border-right: 1px solid white;
}

.qr-code-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 100%;
}

.qr-code-date {
  font-size: 10px;
  font-style: italic;
}

.range-labels {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  font-size: 12px;
}

.qr-code-width-range {
  margin: 10px;
}

.qr-code-range-title {
  font-size: 15px;
  font-weight: bold;
}

ion-range::part(pin) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--ion-color-primary);
  color: #fff;
  border-radius: 16px;
  transform: scale(1.01);
  top: -20px;
  width: 60px;
  height: 30px;
  transition: transform 120ms ease, background 120ms ease;
}

ion-range::part(pin)::before {
  content: none;
}

.chart-toggle-container {
  margin-bottom: 10px;
  display: flex;
  justify-content: center;
  height: 50px;
}

ion-segment {
  --background: var(--ion-color-light);
  width: 100%;
  height: auto;
}

.popover-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-header {
  height: 15%;
  display: flex;
  justify-content: center;
  padding: 4px;
}

.battery-title {
  font-weight: bold;
  left: 10px;
  width: auto;
  margin: 0;
  white-space: nowrap;
}

.card-content {
  height: 85%;
  flex: 1;
  padding: 0;
  overflow: hidden;
  margin-right: var(--spacing-large);
}
@media (max-width: 599px) {
  .card-content {
    height: auto;
    overflow: visible;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .card-content {
    height: auto;
    overflow: visible;
  }
}
@media (min-width: 1024px) {
  .card-content {
    flex: 1;
    min-height: 0;
    height: auto;
    margin-right: 0;
  }
}

/* Battery Summary Container */
.batteries-summary-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  padding: var(--spacing-small);
  padding-right: var(--spacing-large);
  overflow-y: auto;
  min-width: 0;
}
@media (max-width: 599px) {
  .batteries-summary-container {
    padding-right: var(--spacing-small);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .batteries-summary-container {
    height: auto;
    overflow-y: auto;
    padding-right: var(--spacing-small);
  }
}
@media (min-width: 1024px) {
  .batteries-summary-container {
    flex: 1;
    min-height: 0;
    flex-direction: row;
    padding: var(--spacing-medium);
    gap: var(--spacing-small);
    align-items: stretch;
    overflow: hidden;
  }
}

/* Battery Consumption Chart Section */
.consumption-chart-section {
  width: 100%;
  min-width: 0;
}
@media (max-width: 599px) {
  .consumption-chart-section {
    flex: 0 0 auto;
    max-height: 30vh;
    min-height: 180px;
    margin-bottom: var(--spacing-medium);
    overflow: hidden;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .consumption-chart-section {
    flex: 0 0 auto;
    max-height: 30vh;
    min-height: 180px;
    margin-bottom: var(--spacing-medium);
    overflow: hidden;
  }
}
@media (min-width: 1024px) {
  .consumption-chart-section {
    min-height: auto;
    height: auto;
    flex: 1.35 1 0;
    width: auto;
    margin-right: 0;
  }
}

/* Info Cards Section: 4 cards layout */
.info-cards-section {
  display: grid;
  gap: var(--spacing-small);
  width: 100%;
  min-width: 0;
}
@media (max-width: 599px) {
  .info-cards-section {
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
    flex: 0 0 auto;
    min-height: auto;
    margin-bottom: var(--spacing-xs);
    gap: var(--spacing-medium);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .info-cards-section {
    grid-template-columns: 1fr;
    grid-auto-rows: auto;
    flex: 0 0 auto;
    min-height: auto;
    margin-bottom: var(--spacing-xs);
    gap: var(--spacing-medium);
  }
}
@media (min-width: 1024px) {
  .info-cards-section {
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-auto-rows: 1fr;
    gap: var(--spacing-xs);
    flex: 1.05 1 0;
    width: auto;
    height: auto;
    margin-right: 0;
  }
}

/* Capacity/Discharge Charts Section */
.capacity-discharge-section {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 100%;
  gap: var(--spacing-small);
  min-width: 0;
  align-items: stretch;
}
@media (max-width: 599px) {
  .capacity-discharge-section {
    flex: 0 0 auto;
    min-height: 0;
    max-height: 200px;
    overflow: auto;
    margin-bottom: var(--spacing-xs);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .capacity-discharge-section {
    flex: 0 0 auto;
    min-height: 0;
    margin-bottom: var(--spacing-xs);
  }
}
@media (min-width: 1024px) {
  .capacity-discharge-section {
    min-height: auto;
    height: auto;
    flex: 1.15 1 0;
    width: auto;
    margin-right: 0;
  }
}

/* Operations Section: Last Operations */
.operations-section {
  width: 100%;
  display: flex;
  min-width: 0;
}
@media (max-width: 599px) {
  .operations-section {
    min-height: 150px;
    flex: 0 0 auto;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .operations-section {
    min-height: 150px;
    flex: 0 0 auto;
  }
}
@media (min-width: 1024px) {
  .operations-section {
    flex: 1.05 1 0;
    height: auto;
    width: auto;
  }
}

.chart-container {
  height: 100%;
  width: 100%;
  margin: 0px;
}

.top-summary-card {
  height: 50%;
  padding-bottom: 5px;
  margin: 0px !important;
}

.bottom-summary-card {
  height: 50%;
  padding-top: 5px;
  margin: 0px !important;
}

.card-title-label {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ion-color-primary);
  text-align: center;
  font-weight: 500;
}
@media (max-width: 599px) {
  .card-title-label {
    font-size: clamp(0.7rem, 1.6vmin, 0.85rem);
    line-height: 1.1;
    text-align: center;
    flex: 0 0 auto;
    padding: 0 var(--spacing-xs);
    margin-right: auto;
    margin-left: var(--spacing-medium);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .card-title-label {
    font-size: clamp(0.75rem, 1.3vmin, 0.95rem);
  }
}
@media (min-width: 1024px) {
  .card-title-label {
    font-size: clamp(0.85rem, 1.1vmin, 1.1rem);
  }
}

.card-content-label {
  display: flex !important;
  text-align: center;
  align-items: center !important;
  justify-content: center !important;
  width: 100%;
  font-weight: 600;
}
@media (max-width: 599px) {
  .card-content-label {
    font-size: clamp(0.65rem, 1.5vmin, 0.8rem);
    line-height: 1.1;
    justify-content: flex-end !important;
    flex: 0 0 auto !important;
    text-align: right;
    min-width: 0;
    max-width: 45% !important;
    padding: 0 var(--spacing-xs);
    margin-right: var(--spacing-medium);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .card-content-label {
    font-size: clamp(0.7rem, 1.2vmin, 0.9rem);
  }
}
@media (min-width: 1024px) {
  .card-content-label {
    font-size: clamp(0.95rem, 2vmin, 1.3rem);
  }
}

.info-card-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  margin: 0;
  padding: var(--spacing-xs);
  overflow: hidden;
  border-radius: var(--border-radius-small);
  background-color: rgba(0, 0, 0, 0.02);
}
@media (max-width: 599px) {
  .info-card-content {
    padding: var(--spacing-small);
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: auto;
    min-height: 45px;
    gap: var(--spacing-xs);
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .info-card-content {
    padding: var(--spacing-small);
    flex-direction: row;
    align-items: center;
    justify-content: center;
    height: auto;
    min-height: 45px;
    gap: var(--spacing-xs);
  }
}
@media (min-width: 1024px) {
  .info-card-content {
    padding: var(--spacing-small);
  }
}

.operations-card {
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100%;
}
@media (max-width: 599px) {
  .operations-card {
    height: auto;
    min-height: 180px;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .operations-card {
    height: auto;
    min-height: 180px;
  }
}

.operations-list-container {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-xs);
}

.last-operations-info-label {
  display: block;
  text-align: center;
  color: var(--ion-color-dark);
  --color: var(--ion-color-dark);
  padding: var(--spacing-xs);
  border-radius: 4px;
  background-color: rgba(0, 0, 0, 0.03);
  min-height: auto;
}
@media (max-width: 599px) {
  .last-operations-info-label {
    font-size: clamp(0.5rem, 1.2vmin, 0.65rem);
    line-height: 1;
  }
}
@media (min-width: 600px) and (max-width: 1023px) {
  .last-operations-info-label {
    font-size: clamp(0.6rem, 0.95vmin, 0.7rem);
  }
}
@media (min-width: 1024px) {
  .last-operations-info-label {
    font-size: clamp(0.65rem, 0.8vmin, 0.75rem);
  }
}
.last-operations-info-label ion-label {
  color: var(--ion-color-dark);
  display: block;
  word-break: break-word;
}

.header-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 10px;
}

.card-container-no-summary,
.card-container-summary {
  display: flex;
  flex-direction: column;
  justify-content: center !important;
  align-items: center !important;
  height: 100%;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.card-container-summary > * {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

ion-col {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  overflow: hidden !important;
  min-height: 0 !important;
}

ion-grid.general-full-height {
  display: flex !important;
  flex: 1 !important;
  height: 100% !important;
  min-height: 0 !important;
  overflow: hidden !important;
  width: 100% !important;
}

ion-col[size="1.5"] .top-summary-card ion-card, ion-col[size="1.5"] .bottom-summary-card ion-card {
  flex: 1 !important;
  margin: 0 !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: flex-start !important;
  align-items: center !important;
}
ion-col[size="1.5"] .top-summary-card {
  padding-bottom: 5px !important;
}
ion-col[size="1.5"] .bottom-summary-card {
  padding-top: 5px !important;
}

ion-col[size="3"] {
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
ion-col[size="3"] .chart-container {
  width: 100% !important;
  height: 100% !important;
}

.operations-column {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
  overflow: hidden !important;
  max-height: 100% !important;
  flex: 1 !important;
}

.operations-column ion-card {
  height: 100% !important;
  display: flex !important;
  flex-direction: column !important;
  margin: 0 !important;
  overflow: hidden !important;
}

.operations-column .card-title-label {
  flex-shrink: 0 !important;
}

.operations-list-container {
  flex: 1 !important;
  overflow-y: auto !important;
  overflow-x: hidden !important;
  min-height: 0 !important;
}

.hidden {
  display: none;
}

.battery-charts-section-header {
  height: 15%;
  display: flex;
  align-items: stretch;
  width: 100% !important;
  padding: 0;
  margin: 0;
}

.battery-charts-section-content {
  height: 85%;
  width: 100%;
}

.battery-charts-section-label {
  width: 100%;
  min-width: 100%;
  font-size: clamp(0.15rem, 1.2vmin, 1.25rem);
  padding: 3px;
  margin: 0px;
  white-space: normal !important;
  overflow: visible;
  text-overflow: clip;
  line-height: 1.2;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.battery-charts-section-header ion-segment {
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
  height: 100%;
  display: flex;
  align-items: stretch;
  padding: 0;
}

.battery-charts-section-header ion-segment-button {
  height: 100%;
  min-height: 100%;
  width: 50%;
  min-width: 0;
  max-width: 100%;
  flex: 1 1 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  white-space: normal !important;
  overflow: visible;
  text-overflow: clip;
  line-height: 1.2;
  margin: 0px;
  padding: 0px;
}
.battery-charts-section-header ion-segment-button ion-label {
  text-align: center;
  width: 100%;
  margin: 0 auto;
  padding: 0 4px;
  font-size: clamp(0.65rem, 1.2vmin, 0.85rem);
}

/* Battery Charts Header Segment Container */
.battery-charts-header-segment {
  width: 100% !important;
  min-width: 0 !important;
  max-width: 100% !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: stretch;
  padding: 0 !important;
  margin: 0 !important;
  min-height: 44px !important;
  height: auto !important;
}
@media (min-width: 1024px) {
  .battery-charts-header-segment {
    min-height: 40px;
  }
}
.battery-charts-header-segment ion-segment-button {
  --min-width: 0 !important;
  flex: 1 1 50% !important;
  max-width: 50% !important;
  padding: 0 !important;
  text-align: center;
  /* Target the Shadow DOM inner button so slotted content stretches full width */
}
.battery-charts-header-segment ion-segment-button::part(native) {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px;
}
.battery-charts-header-segment ion-segment-button ion-label {
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 100% !important;
  margin: 0 !important;
  padding: 0 4px;
  font-size: clamp(0.65rem, 1.2vmin, 0.85rem);
  line-height: 1.2;
  text-align: center;
  white-space: normal;
  word-break: break-word;
}

/** Media queries to set font size and spacing based on screen size **/
/*#region Small Screens*/
/* Styles for screens smaller than 800px wide or 550 high */
@media (max-width: 800px) or (max-height: 550px) {
  .battery-title {
    font-size: var(--font-size-medium);
  }
  .no-data-label {
    font-size: var(--font-size-medium);
  }
  .table-chip-label {
    display: none;
  }
  .table-chip-icon {
    margin: 0px;
    height: 80%;
    width: 80%;
  }
}
/*#endregion Small Screens*/
/*#region Medium Screens*/
/* Styles for medium screens with min with of 800px and min height of 550px */
@media (min-width: 800px) and (min-height: 550px) {
  .battery-title {
    font-size: var(--font-size-large);
  }
  .no-data-label {
    font-size: var(--font-size-medium);
  }
}
/*#endregion Medium Screens*/
/*#region Larger Screens*/
/* Styles for screens larger than 1000px wide and 600px high */
@media (min-width: 1000px) and (min-height: 600px) {
  .battery-title {
    font-size: var(--font-size-xx-large);
  }
  .no-data-label {
    font-size: var(--font-size-medium);
  }
}
/*#endregion Larger Screens*/
.battery-graph-section {
  width: 100%;
  margin-top: var(--spacing-medium);
  overflow-x: auto;
  overflow-y: visible;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/logbooks/components/log-summaries/batteries-summary/batteries-summary.component.scss","webpack://./src/theme/mocca-breakpoints.scss"],"names":[],"mappings":"AAEA;EACI,cAAA;AADJ;ACqCE;EDrCF;IAIQ,YAAA;EAAN;AACF;;AAGA;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;AAAJ;ACUE;EDfF;IAQQ,gBAAA;EACN;AACF;ACYE;EDtBF;IAYQ,YAAA;IACA,gBAAA;IACA,iBAAA;EAEN;AACF;ACYE;ED7BF;IAkBQ,aAAA;IACA,sBAAA;EAGN;AACF;;AAAA;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,YAAA;EACA,2BAAA;AAGJ;;AAAA;EACI,UAAA;EACA,kBAAA;EACA,YAAA;EAEA,wCAAA;EACA,yCAAA;EACA,uBAAA;EACA,wBAAA;EAEA,kBAAA;EACA,uBAAA;EACA,yCAAA;EACA,qDAAA;EAEA,8BAAA;EACA,qBAAA;EAEA,yBAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;AADJ;ACvCE;EDgBF;IA2BQ,wBAAA;EAAN;AACF;AAEI;EACI,mCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,+BAAA;AAAR;AAGI;EACI,oBAAA;EACA,kBAAA;EACA,aAAA;EACA,SAAA;EACA,2BAAA;EACA,oCAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,UAAA;EACA,oBAAA;EACA,6BAAA;EACA,aAAA;AADR;AAII;EACI,0CAAA;EACA,2BAAA;EACA,sCAAA;EACA,uBAAA;AAFR;AAIQ;EACI,+BAAA;AAFZ;AAKQ;EACI,UAAA;AAHZ;AAOI;EACI,wBAAA;AALR;;AASA;EACI,iBAAA;EACA,WAAA;EACA,0CAAA;AANJ;AC1FE;ED6FF;IAMQ,yCAAA;IACA,gBAAA;EALN;AACF;ACzFE;EDsFF;IAWQ,yCAAA;EAJN;AACF;ACvFE;ED+EF;IAeQ,sCAAA;EAHN;AACF;;AAMA;EACI,WAAA;EACA,eAAA;EACA,wBAAA;EACA,aAAA;EACA,mBAAA;EACA,+BAAA;EACA,uBAAA;EACA,+CAAA;EACA,8JAAA;EACA,gBAAA;AAHJ;;AAMA;EACI,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,WAAA;AAHJ;;AAMA;EACI,wBAAA;EACA,kCAAA;EACA,8BAAA;AAHJ;;AAMA;EACI,wBAAA;AAHJ;;AAMA;EACI,2CAAA;AAHJ;;AAOA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;AAJJ;;AAOA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAJJ;;AAOA;EACI,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,0CAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,8CAAA;AAJJ;;AAOA;EACI,oCAAA;AAJJ;;AAOA;EACI,+BAAA;AAJJ;;AAOA;;;EAGI,UAAA;EACA,YAAA;AAJJ;;AAOA;EACI,6BAAA;AAJJ;;AAOA;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;AAJJ;;AAOA;EACI,eAAA;EACA,kBAAA;AAJJ;;AAOA;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;AAJJ;;AAOA;EACI,YAAA;AAJJ;;AAOA;EACI,eAAA;EACA,iBAAA;AAJJ;;AAOA;EACI,oBAAA;EACA,mBAAA;EACA,uBAAA;EAEA,oCAAA;EACA,WAAA;EAEA,mBAAA;EACA,sBAAA;EAEA,UAAA;EAEA,WAAA;EACA,YAAA;EACA,uDAAA;AARJ;;AAWA;EACI,aAAA;AARJ;;AAWA;EACI,mBAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;AARJ;;AAWA;EACI,oCAAA;EACA,WAAA;EACA,YAAA;AARJ;;AAWA;EACI,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AARJ;;AAWA;EACI,WAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;AARJ;;AAWA;EACI,iBAAA;EACA,UAAA;EACA,WAAA;EACA,SAAA;EACA,mBAAA;AARJ;;AAWA;EACI,WAAA;EACA,OAAA;EACA,UAAA;EACA,gBAAA;EACA,kCAAA;AARJ;AC7RE;EDgSF;IAQQ,YAAA;IACA,iBAAA;EAPN;AACF;AC5RE;EDyRF;IAaQ,YAAA;IACA,iBAAA;EANN;AACF;AC3RE;EDkRF;IAkBQ,OAAA;IACA,aAAA;IACA,YAAA;IACA,eAAA;EALN;AACF;;AAQA,8BAAA;AACA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,sBAAA;EACA,6BAAA;EACA,mCAAA;EACA,gBAAA;EACA,YAAA;AALJ;AC/TE;ED0TF;IAaQ,mCAAA;EAJN;AACF;AC7TE;EDmTF;IAiBQ,YAAA;IACA,gBAAA;IACA,mCAAA;EAHN;AACF;AC7TE;ED4SF;IAuBQ,OAAA;IACA,aAAA;IACA,mBAAA;IACA,8BAAA;IACA,yBAAA;IACA,oBAAA;IACA,gBAAA;EAFN;AACF;;AAKA,sCAAA;AACA;EACI,WAAA;EACA,YAAA;AAFJ;AC5VE;ED4VF;IAKQ,cAAA;IACA,gBAAA;IACA,iBAAA;IACA,oCAAA;IACA,gBAAA;EADN;AACF;AC9VE;EDqVF;IAaQ,cAAA;IACA,gBAAA;IACA,iBAAA;IACA,oCAAA;IACA,gBAAA;EAAN;AACF;AChWE;ED8UF;IAqBQ,gBAAA;IACA,YAAA;IACA,cAAA;IACA,WAAA;IACA,eAAA;EACN;AACF;;AAEA,uCAAA;AACA;EACI,aAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;AACJ;AC/XE;ED0XF;IAOQ,0BAAA;IACA,oBAAA;IACA,cAAA;IACA,gBAAA;IACA,gCAAA;IACA,0BAAA;EAEN;AACF;AClYE;EDmXF;IAgBQ,0BAAA;IACA,oBAAA;IACA,cAAA;IACA,gBAAA;IACA,gCAAA;IACA,0BAAA;EAGN;AACF;ACrYE;ED4WF;IAyBQ,8BAAA;IACA,2BAAA;IACA,mBAAA;IACA,sBAAA;IACA,cAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;EAIN;AACF;;AADA,sCAAA;AACA;EACI,aAAA;EACA,sBAAA;EACA,WAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;AAIJ;AC1aE;ED+ZF;IAUQ,cAAA;IACA,aAAA;IACA,iBAAA;IACA,cAAA;IACA,gCAAA;EAKN;AACF;AC5aE;EDwZF;IAkBQ,cAAA;IACA,aAAA;IACA,gCAAA;EAMN;AACF;AC5aE;EDiZF;IAwBQ,gBAAA;IACA,YAAA;IACA,cAAA;IACA,WAAA;IACA,eAAA;EAON;AACF;;AAJA,wCAAA;AACA;EACI,WAAA;EACA,aAAA;EACA,YAAA;AAOJ;AC1cE;EDgcF;IAMQ,iBAAA;IACA,cAAA;EAQN;AACF;ACzcE;EDybF;IAWQ,iBAAA;IACA,cAAA;EASN;AACF;ACxcE;EDkbF;IAgBQ,cAAA;IACA,YAAA;IACA,WAAA;EAUN;AACF;;AAPA;EACI,YAAA;EACA,WAAA;EACA,WAAA;AAUJ;;AAPA;EACI,WAAA;EACA,mBAAA;EACA,sBAAA;AAUJ;;AAPA;EACI,WAAA;EACA,gBAAA;EACA,sBAAA;AAUJ;;AAPA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,kBAAA;EACA,gBAAA;AAUJ;ACxfE;EDweF;IASQ,0CAAA;IACA,gBAAA;IACA,kBAAA;IACA,cAAA;IACA,4BAAA;IACA,kBAAA;IACA,kCAAA;EAWN;AACF;AC5fE;EDieF;IAmBQ,2CAAA;EAYN;AACF;AC1fE;ED0dF;IAuBQ,0CAAA;EAaN;AACF;;AAVA;EACI,wBAAA;EACA,kBAAA;EACA,8BAAA;EACA,kCAAA;EACA,WAAA;EACA,gBAAA;AAaJ;ACthBE;EDmgBF;IASQ,0CAAA;IACA,gBAAA;IACA,oCAAA;IACA,yBAAA;IACA,iBAAA;IACA,YAAA;IACA,yBAAA;IACA,4BAAA;IACA,mCAAA;EAcN;AACF;AC5hBE;ED4fF;IAqBQ,yCAAA;EAeN;AACF;AC1hBE;EDqfF;IAyBQ,wCAAA;EAgBN;AACF;;AAbA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,0BAAA;EACA,gBAAA;EACA,yCAAA;EACA,qCAAA;AAgBJ;ACzjBE;EDgiBF;IAYQ,6BAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;IACA,gBAAA;IACA,sBAAA;EAiBN;AACF;AC7jBE;EDyhBF;IAsBQ,6BAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,YAAA;IACA,gBAAA;IACA,sBAAA;EAkBN;AACF;ACjkBE;EDkhBF;IAgCQ,6BAAA;EAmBN;AACF;;AAhBA;EACI,aAAA;EACA,sBAAA;EACA,OAAA;EACA,YAAA;AAmBJ;AC3lBE;EDokBF;IAOQ,YAAA;IACA,iBAAA;EAoBN;AACF;AC1lBE;ED6jBF;IAYQ,YAAA;IACA,iBAAA;EAqBN;AACF;;AAlBA;EACI,OAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,sBAAA;AAqBJ;;AAlBA;EACI,cAAA;EACA,kBAAA;EACA,4BAAA;EACA,8BAAA;EACA,0BAAA;EACA,kBAAA;EACA,qCAAA;EACA,gBAAA;AAqBJ;AC1nBE;ED6lBF;IAWQ,0CAAA;IACA,cAAA;EAsBN;AACF;ACznBE;EDslBF;IAgBQ,0CAAA;EAuBN;AACF;ACvnBE;ED+kBF;IAoBQ,2CAAA;EAwBN;AACF;AAtBI;EACE,4BAAA;EACA,cAAA;EACA,sBAAA;AAwBN;;AApBA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,SAAA;AAuBJ;;AApBA;;EAEI,aAAA;EACA,sBAAA;EACA,kCAAA;EACA,8BAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,sBAAA;AAuBJ;;AApBA;EACI,WAAA;EACA,eAAA;EACA,YAAA;AAuBJ;;AApBA;EACI,wBAAA;EACA,iCAAA;EACA,uBAAA;EACA,2BAAA;EACA,wBAAA;AAuBJ;;AApBA;EACI,wBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wBAAA;EACA,2BAAA;EACA,sBAAA;AAuBJ;;AAlBQ;EACI,kBAAA;EACA,oBAAA;EACA,wBAAA;EACA,iCAAA;EACA,sCAAA;EACA,8BAAA;AAqBZ;AAjBI;EACI,8BAAA;AAmBR;AAhBI;EACI,2BAAA;AAkBR;;AAdA;EACI,wBAAA;EACA,8BAAA;EACA,kCAAA;AAiBJ;AAfI;EACI,sBAAA;EACA,uBAAA;AAiBR;;AAbA;EACI,wBAAA;EACA,iCAAA;EACA,uBAAA;EACA,2BAAA;EACA,2BAAA;EACA,kBAAA;AAgBJ;;AAbA;EACI,uBAAA;EACA,wBAAA;EACA,iCAAA;EACA,oBAAA;EACA,2BAAA;AAgBJ;;AAbA;EACI,yBAAA;AAgBJ;;AAbA;EACI,kBAAA;EACA,2BAAA;EACA,6BAAA;EACA,wBAAA;AAgBJ;;AAbA;EACI,aAAA;AAgBJ;;AAbA;EACI,WAAA;EACA,aAAA;EACA,oBAAA;EACA,sBAAA;EACA,UAAA;EACA,SAAA;AAgBJ;;AAbA;EACI,WAAA;EACA,WAAA;AAgBJ;;AAbA;EACI,WAAA;EACA,eAAA;EACA,2CAAA;EACA,YAAA;EACA,WAAA;EACA,8BAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAgBJ;;AAbA;EACI,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,YAAA;EACA,aAAA;EACA,oBAAA;EACA,UAAA;AAgBJ;;AAbA;EACI,YAAA;EACA,gBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,8BAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAgBJ;AAdI;EACI,kBAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;EACA,2CAAA;AAgBR;;AAZA,4CAAA;AACA;EACI,sBAAA;EACA,uBAAA;EACA,0BAAA;EACA,wBAAA;EACA,8BAAA;EACA,oBAAA;EACA,qBAAA;EACA,oBAAA;EACA,2BAAA;EACA,uBAAA;AAeJ;ACxzBE;ED+xBF;IAaQ,gBAAA;EAgBN;AACF;AAdI;EACI,yBAAA;EACA,wBAAA;EACA,yBAAA;EACA,qBAAA;EACA,kBAAA;EAEA,+EAAA;AAeR;AAdQ;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AAgBZ;AAbQ;EACI,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,sBAAA;EACA,oBAAA;EACA,cAAA;EACA,2CAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;AAeZ;;AAVA,sEAAA;AAEA,wBAAA;AAEA,2DAAA;AACA;EAEI;IACI,kCAAA;EAUN;EAPE;IACI,kCAAA;EASN;EANE;IACI,aAAA;EAQN;EALE;IACI,WAAA;IACA,WAAA;IACA,UAAA;EAON;AACF;AAJA,2BAAA;AAEA,yBAAA;AAEE,6EAAA;AACF;EAEI;IACI,iCAAA;EAGN;EAAE;IACI,kCAAA;EAEN;AACF;AACA,4BAAA;AAEA,yBAAA;AAEE,8DAAA;AACF;EAEI;IACI,oCAAA;EAFN;EAKE;IACI,kCAAA;EAHN;AACF;AAMA,4BAAA;AAEA;EACI,WAAA;EACA,iCAAA;EACA,gBAAA;EACA,mBAAA;AALJ","sourcesContent":["@use 'src/theme/mocca-breakpoints' as bp;\r\n\r\n:host {\r\n    display: block;\r\n\r\n    @include bp.desktop {\r\n        height: 100%;\r\n    }\r\n}\r\n\r\nion-card {\r\n    width: 100%;\r\n    height: 100%;\r\n    margin: 0;\r\n    overflow: hidden;\r\n    box-sizing: border-box;\r\n\r\n    @include bp.mobile {\r\n        min-height: 85vh;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        height: auto;\r\n        min-height: 85vh;\r\n        overflow: visible;\r\n    }\r\n\r\n    @include bp.desktop {\r\n        display: flex;\r\n        flex-direction: column;\r\n    }\r\n}\r\n\r\n.time-filter {\r\n    position: absolute;\r\n    z-index: 990;\r\n    width: 70%;\r\n    height: 100%;\r\n    right: var(--spacing-small);\r\n}\r\n\r\n.download-qr-button {\r\n    opacity: 1;\r\n    position: relative;\r\n    z-index: 990;\r\n\r\n    width: clamp(24px, 4vh, 36px) !important;\r\n    height: clamp(24px, 4vh, 36px) !important;\r\n    min-width: 0 !important;\r\n    min-height: 0 !important;\r\n\r\n    border-radius: 50%;\r\n    background-color: white;\r\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);\r\n    border: 2px solid var(--ion-color-primary) !important;\r\n\r\n    margin: 0 var(--spacing-small);\r\n    padding: 0 !important;\r\n\r\n    transition: all 0.3s ease;\r\n    cursor: pointer;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    flex-shrink: 0;\r\n    aspect-ratio: 1;\r\n\r\n    @include bp.mobile {\r\n        display: none !important;\r\n    }\r\n\r\n    ion-icon {\r\n        font-size: clamp(14px, 2.5vh, 20px);\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        margin: 0;\r\n        color: var(--ion-color-primary);\r\n    }\r\n\r\n    &::after {\r\n        content: attr(title);\r\n        position: absolute;\r\n        bottom: -35px;\r\n        left: 50%;\r\n        transform: translateX(-50%);\r\n        background-color: rgba(0, 0, 0, 0.8);\r\n        color: white;\r\n        padding: 6px 12px;\r\n        border-radius: 4px;\r\n        font-size: 12px;\r\n        white-space: nowrap;\r\n        opacity: 0;\r\n        pointer-events: none;\r\n        transition: opacity 0.3s ease;\r\n        z-index: 1000;\r\n    }\r\n\r\n    &:hover {\r\n        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);\r\n        transform: translateY(-2px);\r\n        border-color: var(--ion-color-primary);\r\n        background-color: white;\r\n\r\n        ion-icon {\r\n            color: var(--ion-color-primary);\r\n        }\r\n\r\n        &::after {\r\n            opacity: 1;\r\n        }\r\n    }\r\n\r\n    &:active {\r\n        transform: translateY(0);\r\n    }\r\n}\r\n\r\n.battery-title {\r\n    font-weight: bold;\r\n    width: auto;\r\n    color: var(--ion-color-primary) !important;\r\n\r\n    @include bp.mobile {\r\n        font-size: clamp(0.65rem, 1.3vw, 0.85rem);\r\n        line-height: 1.1;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        font-size: clamp(0.75rem, 1.2vw, 0.95rem);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        font-size: clamp(0.85rem, 1vw, 1.1rem);\r\n    }\r\n}\r\n\r\n.card-header {\r\n    height: 5vh;\r\n    max-height: 5vh;\r\n    min-height: 0 !important;\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 0 var(--spacing-small);\r\n    color: white !important;\r\n    border-left: 5px solid var(--ion-color-primary);\r\n    background: linear-gradient(90deg, color-mix(in srgb, var(--ion-color-primary) 12%, white), color-mix(in srgb, var(--ion-color-primary) 3%, white)) !important;\r\n    overflow: hidden;\r\n}\r\n\r\n.header-content {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: var(--spacing-medium);\r\n    width: 100%;\r\n}\r\n\r\nion-chip {\r\n    display: flex !important;\r\n    justify-content: center !important;\r\n    align-items: center !important;\r\n}\r\n\r\n.hide-label {\r\n    display: none !important;\r\n}\r\n\r\n.table-chip-button {\r\n    font-size: clamp(0.35rem, 1.8vmin, 1.25rem);\r\n}\r\n\r\n\r\n.qr-button-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    height: 100%;\r\n}\r\n\r\n.popover-footer {\r\n    position: absolute;\r\n    bottom: 0;\r\n    width: 100%;\r\n    height: 60px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.qr-buttons {\r\n    height: 100%;\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    cursor: pointer;\r\n    background-color: var(--ion-color-primary);\r\n    color: white;\r\n    padding: var(--spacing-small);\r\n    text-align: center;\r\n    transition: background-color 0.3s, filter 0.3s;\r\n}\r\n\r\n.qr-buttons:hover {\r\n    background-color: rgba(1, 1, 1, 0.1);\r\n}\r\n\r\n.qr-buttons:hover ion-icon {\r\n    color: var(--ion-color-primary);\r\n}\r\n\r\n.batteriesQRCodePopover ion-grid,\r\n.batteriesQRCodePopover ion-col,\r\n.batteriesQRCodePopover ion-row {\r\n    padding: 0;\r\n    height: 100%;\r\n}\r\n\r\n.batteriesQRCodePopover ion-col:first-child {\r\n    border-right: 1px solid white;\r\n}\r\n\r\n.qr-code-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n    height: 100%;\r\n}\r\n\r\n.qr-code-date {\r\n    font-size: 10px;\r\n    font-style: italic;\r\n}\r\n\r\n.range-labels {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    width: 100%;\r\n    font-size: 12px;\r\n}\r\n\r\n.qr-code-width-range {\r\n    margin: 10px;\r\n}\r\n\r\n.qr-code-range-title {\r\n    font-size: 15px;\r\n    font-weight: bold;\r\n}\r\n\r\nion-range::part(pin) {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n\r\n    background: var(--ion-color-primary);\r\n    color: #fff;\r\n\r\n    border-radius: 16px;\r\n    transform: scale(1.01);\r\n\r\n    top: -20px;\r\n\r\n    width: 60px;\r\n    height: 30px;\r\n    transition: transform 120ms ease, background 120ms ease;\r\n}\r\n\r\nion-range::part(pin)::before {\r\n    content: none;\r\n}\r\n\r\n.chart-toggle-container {\r\n    margin-bottom: 10px;\r\n    display: flex;\r\n    justify-content: center;\r\n    height: 50px;\r\n}\r\n\r\nion-segment {\r\n    --background: var(--ion-color-light);\r\n    width: 100%;\r\n    height: auto;\r\n}\r\n\r\n.popover-footer {\r\n    position: absolute;\r\n    bottom: 0;\r\n    width: 100%;\r\n    height: 60px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.card-header {\r\n    height: 15%;\r\n    display: flex;\r\n    justify-content: center;\r\n    padding: 4px;\r\n}\r\n\r\n.battery-title {\r\n    font-weight: bold;\r\n    left: 10px;\r\n    width: auto;\r\n    margin: 0;\r\n    white-space: nowrap;\r\n}\r\n\r\n.card-content {\r\n    height: 85%;\r\n    flex: 1;\r\n    padding: 0;\r\n    overflow: hidden;\r\n    margin-right: var(--spacing-large);\r\n\r\n    @include bp.mobile {\r\n        height: auto;\r\n        overflow: visible;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        height: auto;\r\n        overflow: visible;\r\n    }\r\n\r\n    @include bp.desktop {\r\n        flex: 1;\r\n        min-height: 0;\r\n        height: auto;\r\n        margin-right: 0;\r\n    }\r\n}\r\n\r\n/* Battery Summary Container */\r\n.batteries-summary-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    box-sizing: border-box;\r\n    padding: var(--spacing-small);\r\n    padding-right: var(--spacing-large);\r\n    overflow-y: auto;\r\n    min-width: 0;\r\n\r\n    @include bp.mobile {\r\n        padding-right: var(--spacing-small);\r\n    }\r\n\r\n    @include bp.tablet {\r\n        height: auto;\r\n        overflow-y: auto;\r\n        padding-right: var(--spacing-small);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        flex: 1;\r\n        min-height: 0;\r\n        flex-direction: row;\r\n        padding: var(--spacing-medium);\r\n        gap: var(--spacing-small);\r\n        align-items: stretch;\r\n        overflow: hidden;\r\n    }\r\n}\r\n\r\n/* Battery Consumption Chart Section */\r\n.consumption-chart-section {\r\n    width: 100%;\r\n    min-width: 0;\r\n\r\n    @include bp.mobile {\r\n        flex: 0 0 auto;\r\n        max-height: 30vh;\r\n        min-height: 180px;\r\n        margin-bottom: var(--spacing-medium);\r\n        overflow: hidden;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        flex: 0 0 auto;\r\n        max-height: 30vh;\r\n        min-height: 180px;\r\n        margin-bottom: var(--spacing-medium);\r\n        overflow: hidden;\r\n    }\r\n\r\n    @include bp.desktop {\r\n        min-height: auto;\r\n        height: auto;\r\n        flex: 1.35 1 0;\r\n        width: auto;\r\n        margin-right: 0;\r\n    }\r\n}\r\n\r\n/* Info Cards Section: 4 cards layout */\r\n.info-cards-section {\r\n    display: grid;\r\n    gap: var(--spacing-small);\r\n    width: 100%;\r\n    min-width: 0;\r\n\r\n    @include bp.mobile {\r\n        grid-template-columns: 1fr;\r\n        grid-auto-rows: auto;\r\n        flex: 0 0 auto;\r\n        min-height: auto;\r\n        margin-bottom: var(--spacing-xs);\r\n        gap: var(--spacing-medium);\r\n    }\r\n\r\n    @include bp.tablet {\r\n        grid-template-columns: 1fr;\r\n        grid-auto-rows: auto;\r\n        flex: 0 0 auto;\r\n        min-height: auto;\r\n        margin-bottom: var(--spacing-xs);\r\n        gap: var(--spacing-medium);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        grid-template-columns: 1fr 1fr;\r\n        grid-template-rows: 1fr 1fr;\r\n        grid-auto-rows: 1fr;\r\n        gap: var(--spacing-xs);\r\n        flex: 1.05 1 0;\r\n        width: auto;\r\n        height: auto;\r\n        margin-right: 0;\r\n    }\r\n}\r\n\r\n/* Capacity/Discharge Charts Section */\r\n.capacity-discharge-section {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    gap: var(--spacing-small);\r\n    min-width: 0;\r\n    align-items: stretch;\r\n\r\n    @include bp.mobile {\r\n        flex: 0 0 auto;\r\n        min-height: 0;\r\n        max-height: 200px;\r\n        overflow: auto;\r\n        margin-bottom: var(--spacing-xs);\r\n    }\r\n\r\n    @include bp.tablet {\r\n        flex: 0 0 auto;\r\n        min-height: 0;\r\n        margin-bottom: var(--spacing-xs);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        min-height: auto;\r\n        height: auto;\r\n        flex: 1.15 1 0;\r\n        width: auto;\r\n        margin-right: 0;\r\n    }\r\n}\r\n\r\n/* Operations Section: Last Operations */\r\n.operations-section {\r\n    width: 100%;\r\n    display: flex;\r\n    min-width: 0;\r\n\r\n    @include bp.mobile {\r\n        min-height: 150px;\r\n        flex: 0 0 auto;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        min-height: 150px;\r\n        flex: 0 0 auto;\r\n    }\r\n\r\n    @include bp.desktop {\r\n        flex: 1.05 1 0;\r\n        height: auto;\r\n        width: auto;\r\n    }\r\n}\r\n\r\n.chart-container {\r\n    height: 100%;\r\n    width: 100%;\r\n    margin: 0px;\r\n}\r\n\r\n.top-summary-card {\r\n    height: 50%;\r\n    padding-bottom: 5px;\r\n    margin: 0px !important;\r\n}\r\n\r\n.bottom-summary-card {\r\n    height: 50%;\r\n    padding-top: 5px;\r\n    margin: 0px !important;\r\n}\r\n\r\n.card-title-label {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    color: var(--ion-color-primary);\r\n    text-align: center;\r\n    font-weight: 500;\r\n\r\n    @include bp.mobile {\r\n        font-size: clamp(0.7rem, 1.6vmin, 0.85rem);\r\n        line-height: 1.1;\r\n        text-align: center;\r\n        flex: 0 0 auto;\r\n        padding: 0 var(--spacing-xs);\r\n        margin-right: auto;\r\n        margin-left: var(--spacing-medium);\r\n    }\r\n\r\n    @include bp.tablet {\r\n        font-size: clamp(0.75rem, 1.3vmin, 0.95rem);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        font-size: clamp(0.85rem, 1.1vmin, 1.1rem);\r\n    }\r\n}\r\n\r\n.card-content-label {\r\n    display: flex !important;\r\n    text-align: center;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n    width: 100%;\r\n    font-weight: 600;\r\n\r\n    @include bp.mobile {\r\n        font-size: clamp(0.65rem, 1.5vmin, 0.8rem);\r\n        line-height: 1.1;\r\n        justify-content: flex-end !important;\r\n        flex: 0 0 auto !important;\r\n        text-align: right;\r\n        min-width: 0;\r\n        max-width: 45% !important;\r\n        padding: 0 var(--spacing-xs);\r\n        margin-right: var(--spacing-medium);\r\n    }\r\n\r\n    @include bp.tablet {\r\n        font-size: clamp(0.7rem, 1.2vmin, 0.9rem);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        font-size: clamp(0.95rem, 2vmin, 1.3rem);\r\n    }\r\n}\r\n\r\n.info-card-content {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    height: 100%;\r\n    margin: 0;\r\n    padding: var(--spacing-xs);\r\n    overflow: hidden;\r\n    border-radius: var(--border-radius-small);\r\n    background-color: rgba(0, 0, 0, 0.02);\r\n\r\n    @include bp.mobile {\r\n        padding: var(--spacing-small);\r\n        flex-direction: row;\r\n        align-items: center;\r\n        justify-content: center;\r\n        height: auto;\r\n        min-height: 45px;\r\n        gap: var(--spacing-xs);\r\n    }\r\n\r\n    @include bp.tablet {\r\n        padding: var(--spacing-small);\r\n        flex-direction: row;\r\n        align-items: center;\r\n        justify-content: center;\r\n        height: auto;\r\n        min-height: 45px;\r\n        gap: var(--spacing-xs);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        padding: var(--spacing-small);\r\n    }\r\n}\r\n\r\n.operations-card {\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex: 1;\r\n    height: 100%;\r\n\r\n    @include bp.mobile {\r\n        height: auto;\r\n        min-height: 180px;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        height: auto;\r\n        min-height: 180px;\r\n    }\r\n}\r\n\r\n.operations-list-container {\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: var(--spacing-xs);\r\n}\r\n\r\n.last-operations-info-label {\r\n    display: block;\r\n    text-align: center;\r\n    color: var(--ion-color-dark);\r\n    --color: var(--ion-color-dark);\r\n    padding: var(--spacing-xs);\r\n    border-radius: 4px;\r\n    background-color: rgba(0, 0, 0, 0.03);\r\n    min-height: auto;\r\n\r\n    @include bp.mobile {\r\n        font-size: clamp(0.5rem, 1.2vmin, 0.65rem);\r\n        line-height: 1;\r\n    }\r\n\r\n    @include bp.tablet {\r\n        font-size: clamp(0.6rem, 0.95vmin, 0.7rem);\r\n    }\r\n\r\n    @include bp.desktop {\r\n        font-size: clamp(0.65rem, 0.8vmin, 0.75rem);\r\n    }\r\n\r\n    ion-label {\r\n      color: var(--ion-color-dark);\r\n      display: block;\r\n      word-break: break-word;\r\n    }\r\n}\r\n\r\n.header-content {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    width: 100%;\r\n    gap: 10px;\r\n}\r\n\r\n.card-container-no-summary,\r\n.card-container-summary {\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center !important;\r\n    align-items: center !important;\r\n    height: 100%;\r\n    width: 100%;\r\n    max-width: 100%;\r\n    min-width: 0;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.card-container-summary > * {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    min-width: 0;\r\n}\r\n\r\nion-col {\r\n    display: flex !important;\r\n    flex-direction: column !important;\r\n    height: 100% !important;\r\n    overflow: hidden !important;\r\n    min-height: 0 !important;\r\n}\r\n\r\nion-grid.general-full-height {\r\n    display: flex !important;\r\n    flex: 1 !important;\r\n    height: 100% !important;\r\n    min-height: 0 !important;\r\n    overflow: hidden !important;\r\n    width: 100% !important;\r\n}\r\n\r\nion-col[size=\"1.5\"] {\r\n    .top-summary-card, .bottom-summary-card {\r\n        ion-card {\r\n            flex: 1 !important;\r\n            margin: 0 !important;\r\n            display: flex !important;\r\n            flex-direction: column !important;\r\n            justify-content: flex-start !important;\r\n            align-items: center !important;\r\n        }\r\n    }\r\n\r\n    .top-summary-card {\r\n        padding-bottom: 5px !important;\r\n    }\r\n\r\n    .bottom-summary-card {\r\n        padding-top: 5px !important;\r\n    }\r\n}\r\n\r\nion-col[size=\"3\"] {\r\n    display: flex !important;\r\n    align-items: center !important;\r\n    justify-content: center !important;\r\n\r\n    .chart-container {\r\n        width: 100% !important;\r\n        height: 100% !important;\r\n    }\r\n}\r\n\r\n.operations-column {\r\n    display: flex !important;\r\n    flex-direction: column !important;\r\n    height: 100% !important;\r\n    overflow: hidden !important;\r\n    max-height: 100% !important;\r\n    flex: 1 !important;\r\n}\r\n\r\n.operations-column ion-card {\r\n    height: 100% !important;\r\n    display: flex !important;\r\n    flex-direction: column !important;\r\n    margin: 0 !important;\r\n    overflow: hidden !important;\r\n}\r\n\r\n.operations-column .card-title-label {\r\n    flex-shrink: 0 !important;\r\n}\r\n\r\n.operations-list-container {\r\n    flex: 1 !important;\r\n    overflow-y: auto !important;\r\n    overflow-x: hidden !important;\r\n    min-height: 0 !important;\r\n}\r\n\r\n.hidden {\r\n    display: none;\r\n}\r\n\r\n.battery-charts-section-header {\r\n    height: 15%;\r\n    display: flex;\r\n    align-items: stretch;\r\n    width: 100% !important;\r\n    padding: 0;\r\n    margin: 0;\r\n}\r\n\r\n.battery-charts-section-content {\r\n    height: 85%;\r\n    width: 100%;\r\n}\r\n\r\n.battery-charts-section-label {\r\n    width: 100%;\r\n    min-width: 100%;\r\n    font-size: clamp(0.15rem, 1.2vmin, 1.25rem);\r\n    padding: 3px;\r\n    margin: 0px;\r\n    white-space: normal !important;\r\n    overflow: visible;\r\n    text-overflow: clip;\r\n    line-height: 1.2;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n}\r\n\r\n.battery-charts-section-header ion-segment {\r\n    width: 100% !important;\r\n    min-width: 0 !important;\r\n    max-width: 100% !important;\r\n    height: 100%;\r\n    display: flex;\r\n    align-items: stretch;\r\n    padding: 0;\r\n}\r\n\r\n.battery-charts-section-header ion-segment-button {\r\n    height: 100%;\r\n    min-height: 100%;\r\n    width: 50%;\r\n    min-width: 0;\r\n    max-width: 100%;\r\n    flex: 1 1 50%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n    white-space: normal !important;\r\n    overflow: visible;\r\n    text-overflow: clip;\r\n    line-height: 1.2;\r\n    margin: 0px;\r\n    padding: 0px;\r\n\r\n    ion-label {\r\n        text-align: center;\r\n        width: 100%;\r\n        margin: 0 auto;\r\n        padding: 0 4px;\r\n        font-size: clamp(0.65rem, 1.2vmin, 0.85rem);\r\n    }\r\n}\r\n\r\n/* Battery Charts Header Segment Container */\r\n.battery-charts-header-segment {\r\n    width: 100% !important;\r\n    min-width: 0 !important;\r\n    max-width: 100% !important;\r\n    display: flex !important;\r\n    flex-direction: row !important;\r\n    align-items: stretch;\r\n    padding: 0 !important;\r\n    margin: 0 !important;\r\n    min-height: 44px !important;\r\n    height: auto !important;\r\n\r\n    @include bp.desktop {\r\n        min-height: 40px;\r\n    }\r\n\r\n    ion-segment-button {\r\n        --min-width: 0 !important;\r\n        flex: 1 1 50% !important;\r\n        max-width: 50% !important;\r\n        padding: 0 !important;\r\n        text-align: center;\r\n\r\n        /* Target the Shadow DOM inner button so slotted content stretches full width */\r\n        &::part(native) {\r\n            width: 100%;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            padding: 6px;\r\n        }\r\n\r\n        ion-label {\r\n            display: flex !important;\r\n            align-items: center;\r\n            justify-content: center;\r\n            width: 100% !important;\r\n            margin: 0 !important;\r\n            padding: 0 4px;\r\n            font-size: clamp(0.65rem, 1.2vmin, 0.85rem);\r\n            line-height: 1.2;\r\n            text-align: center;\r\n            white-space: normal;\r\n            word-break: break-word;\r\n        }\r\n    }\r\n}\r\n\r\n/** Media queries to set font size and spacing based on screen size **/\r\n\r\n/*#region Small Screens*/\r\n\r\n/* Styles for screens smaller than 800px wide or 550 high */\r\n@media (max-width: 800px) or (max-height: 550px) {\r\n\r\n    .battery-title {\r\n        font-size: var(--font-size-medium);\r\n    }\r\n\r\n    .no-data-label {\r\n        font-size: var(--font-size-medium);\r\n    }\r\n\r\n    .table-chip-label {\r\n        display: none;\r\n    }\r\n\r\n    .table-chip-icon {\r\n        margin: 0px;\r\n        height: 80%;\r\n        width: 80%;\r\n    }\r\n\r\n}\r\n/*#endregion Small Screens*/\r\n\r\n/*#region Medium Screens*/\r\n\r\n  /* Styles for medium screens with min with of 800px and min height of 550px */\r\n@media (min-width: 800px) and (min-height: 550px) {\r\n\r\n    .battery-title {\r\n        font-size: var(--font-size-large);\r\n    }\r\n\r\n    .no-data-label {\r\n        font-size: var(--font-size-medium);\r\n    }\r\n}\r\n\r\n/*#endregion Medium Screens*/\r\n\r\n/*#region Larger Screens*/\r\n\r\n  /* Styles for screens larger than 1000px wide and 600px high */\r\n@media (min-width: 1000px) and (min-height: 600px) {\r\n\r\n    .battery-title {\r\n        font-size: var(--font-size-xx-large)\r\n    }\r\n\r\n    .no-data-label {\r\n        font-size: var(--font-size-medium);\r\n    }\r\n}\r\n\r\n/*#endregion Larger Screens*/\r\n\r\n.battery-graph-section {\r\n    width: 100%;\r\n    margin-top: var(--spacing-medium);\r\n    overflow-x: auto;\r\n    overflow-y: visible;\r\n}\r\n","// =============================================================================\r\n//  accord-breakpoints.scss\r\n//\r\n//  Standard 3-tier Responsive Breakpoints for the Accord Design System.\r\n//  Based on Google Material Design 3 guidelines.\r\n//\r\n//  Breakpoints:\r\n//    Mobile  — max-width: 599px\r\n//    Tablet  — min-width: 600px and max-width: 1023px\r\n//    Desktop — min-width: 1024px\r\n//\r\n//  Usage in component SCSS (with @use):\r\n//    @use 'src/theme/mocca-breakpoints' as bp;\r\n//    @include bp.mobile  { ... }\r\n//    @include bp.tablet  { ... }\r\n//    @include bp.desktop { ... }\r\n//\r\n//  Or via raw @media (legacy/global):\r\n//    @media (max-width: 599px)                        { ... }  // mobile\r\n//    @media (min-width: 600px) and (max-width: 1023px){ ... }  // tablet\r\n//    @media (min-width: 1024px)                       { ... }  // desktop\r\n// =============================================================================\r\n\r\n/// Mobile only — screens ≤ 599px\r\n@mixin mobile {\r\n  @media (max-width: 599px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Tablet only — screens 600px–1023px\r\n@mixin tablet {\r\n  @media (min-width: 600px) and (max-width: 1023px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Desktop and above — screens ≥ 1024px\r\n@mixin desktop {\r\n  @media (min-width: 1024px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Tablet and above — screens ≥ 600px (tablet + desktop)\r\n@mixin tablet-up {\r\n  @media (min-width: 600px) {\r\n    @content;\r\n  }\r\n}\r\n\r\n/// Desktop and below — screens ≤ 1023px (mobile + tablet)\r\n@mixin desktop-down {\r\n  @media (max-width: 1023px) {\r\n    @content;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
